import { active } from "@api/stores/customers/active/api";
import { deactive } from "@api/stores/customers/deactive/api";
import { salesInvoices } from "@api/stores/customers/salesInvoices/api";
import { sendMessage } from "@api/stores/customers/sendMessage/api";
import { stats } from "@api/stores/customers/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  ICustomersDto,
  ICustomersGetAllParams,
  ICustomersResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICustomersResponse>>,
  IPathBaseParam,
  IPaginationParams & ICustomersGetAllParams
>("stores.customers");
const postApis = createPostApi<
  IApiResponse<ICustomersResponse>,
  IPathBaseParam,
  ICustomersDto
>("stores.customers");
const getApis = createGetApi<
  IApiResponse<ICustomersResponse>,
  IPathByIdParam,
  object
>("stores.customers");
const patchApis = createPatchApi<
  IApiResponse<ICustomersResponse>,
  IPathByIdParam,
  ICustomersDto
>("stores.customers");

export const customers = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  active,
  deactive,
  stats,
  sendMessage,
  salesInvoices,
};
